'use strict';

angular.module('controllers')
	.directive('flip', function () {
		return {
			restrict: 'AE',
			replace: true,
			link: function (scope, element, attr) {
				angular.element(element[0].querySelector( '.front')).on('click',function(){
					angular.element(element[0].querySelector('.flipped')).css('transform', 'rotateY(180deg)');
				});

				angular.element(element[0].querySelector( '.back')).on('click',function(){
					angular.element(element[0].querySelector('.flipped')).css('transform', 'rotateY(0deg)');
				});
			}
		}
	});
